import { Field } from 'react-final-form'
import { Input } from './FloatingLabelField'

const FloatingLabelFinalField = ({ type = 'text', ...props }) => (
  <Field {...props}>{_props => <Input {...{ type, ..._props }} />}</Field>
)

export default FloatingLabelFinalField
